import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options"],
  _excluded2 = ["indicator"];
import { memo, useMemo } from 'react';
import SelectAdapter from '../../adapters/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectWithIndicator = props => {
  const {
      options
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const normalizedOptions = useMemo(() => {
    if (!options) {
      return options;
    }
    return options.map(option => {
      // If this is a select with nested options, we don't try to modify them
      // We don't have a use case for indicators on nested options at the moment
      // And the new Trellis Select may not support nested options
      if ('options' in option) {
        return option;
      }
      const {
          indicator
        } = option,
        restOption = _objectWithoutPropertiesLoose(option, _excluded2);
      return Object.assign({}, restOption, {
        avatar: restOption.avatar || indicator || undefined
      });
    });
  }, [options]);
  return /*#__PURE__*/_jsx(SelectAdapter, Object.assign({
    options: normalizedOptions
  }, restProps));
};
export default /*#__PURE__*/memo(SelectWithIndicator);